// 🔧 seo_seed_step.js
// ✅ Purpose: SEO Seeder pipeline step
// ✅ Features:
// - Executes the SEO Seeder
// - Writes SEO content to the event document
// - Updates DemoContext with SEO result
// - Keeps SEO seeding modular
// - Fully block-commented for clarity and future devs

import {
  createPipelineStepSuccess,
} from "../pipeline_step";

import {
  seedSeoShell,
} from "../../seeders/event/seo_seeder";

export const createSeoSeedStep = () => ({
  name: "seo_seeder",

  label: "SEO Seeder",

  run: async (context) => {
    const result =
      await seedSeoShell(context);

    return createPipelineStepSuccess({
      step: "seo_seeder",

      label: "SEO Seeder",

      created:
        result?.createdCount || 0,

      message:
        result?.message ||
        "SEO Seeder created event SEO content.",

      metadata:
        result,

      startedAt:
        context.startedAt,
    });
  },

  afterSuccess: ({
    result,
    sharedContext,
  }) => {
    sharedContext.seoResult =
      result?.metadata || null;
  },
});